// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenu-cls1__cc332a6d17e8bd52e9ab{/*!*/}.AccountMenu-cls2___7214687b604ce02f44c{margin:18px 0;padding:0;list-style:none;color:#111}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenu-cls1__cc332a6d17e8bd52e9ab",
	"cls2": "AccountMenu-cls2___7214687b604ce02f44c AccountMenu-cls1__cc332a6d17e8bd52e9ab"
};
export default ___CSS_LOADER_EXPORT___;
